import { QUANTITY_OPTIONS, SHOW_ALL_ITEMS_QUANTITY } from '@/shared/config';
import type { OrderOptions } from '@/shared/lib';

export const CONTENT_QUANTITY_OPTIONS = QUANTITY_OPTIONS.map((option) =>
  option.id === SHOW_ALL_ITEMS_QUANTITY ? { ...option, name: 'Todos os conteúdos' } : option
);

export const CONTENT_ORDER_OPTIONS: OrderOptions[] = [
  { label: 'Por arquivo mais recente', sort: 'createdAt', order: 'desc' },
  { label: 'Por arquivo mais antigo', sort: 'createdAt', order: 'asc' },
  { label: 'Por ordem alfabética crescente', sort: 'title', order: 'asc' },
  { label: 'Por ordem alfabética decrescente', sort: 'title', order: 'desc' },
];

export const CONTENT_TABLE_COLUMN_WIDTH_CLASSES = [
  'w-[30%]',
  'w-[19%] whitespace-nowrap',
  'w-[18%] whitespace-nowrap',
  'w-[19%]',
  'w-[14%]',
];

export function contentTableCellModifierClass(index: number) {
  return CONTENT_TABLE_COLUMN_WIDTH_CLASSES[index].split(' ').slice(1).join(' ');
}
